import { useEffect, useRef, useState } from 'react';
import { useHistory, withRouter, useParams } from "react-router-dom";
import { observer, inject } from "mobx-react";

import Header, { NavList } from "@/components/Base/header";
import Contact from "@/components/Base/contact";
import Footer from "@/components/Base/footer";
import Subscribe from "@/components/Base/subscribe";
import SvgsOthers from "@/components/svgs/others";
import News from "@/components/News/index";
import { newPath } from '@/utils/index'
import { TopInfo, SplitedNewsList } from './utils'
import { Root } from './css'

const Index = ({ store }) => {
  const { isMobile } = store.common;
  const history = useHistory();

  const toTopDetail = () => {
    if (TopInfo.link) {
      window.open(TopInfo.link)
    } else if (TopInfo.id) {
      history.push(`${newPath}/news_detail/${TopInfo.id}`)
    }
  }

  useEffect(() => {
    
  }, [])

  return (
    <Root className={`${isMobile ? 'mobile' : ''}`}>
      <Header currentName={NavList[0].name} />
      <div className="content">
        <div className="center">
          <div className="top">
            <div className="pic" onClick={toTopDetail}>
              <img src={TopInfo.thumb} alt="" />
            </div>
            <div className="detail">
              <h1 onClick={toTopDetail}>{TopInfo.title}</h1>
              <div className="desc" onClick={toTopDetail}>{TopInfo.desc}</div>
              <div className="info">
                <div className="user">
                  {TopInfo.ava && <img src={TopInfo.ava} height={14} />}
                  {TopInfo.name}
                </div>
                <span>{TopInfo.date}</span>
              </div>
            </div>
          </div>
          {SplitedNewsList.map((list, key) => (
            <News list={list} className="news" key={key} />
          ))}
        </div>
      </div>
      <div className="bottom">
        <div className="center">
          <Subscribe />
          <Contact />
          <Footer />
        </div>
      </div>
    </Root>
  )
}

export default withRouter(inject("store")(observer(Index)))